import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import CheckerCancellationTable from '../components/CheckerCancellationTable';
interface CheckerInboxCancellationProps {
  onLogout: () => void;
}
const CheckerInboxCancellation: React.FC<CheckerInboxCancellationProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-2714">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Checker Inbox - Cancellations" data-id="element-2715" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="checker-inbox-cancellation" data-id="element-2716" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: '240px'
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-2717">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-2718">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-2719">
            <Icon icon="lucide:clipboard-check" width={28} height={28} color="#F59E0B" data-id="element-2720" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-2721">
              Checker Inbox - Cancellations
            </Typography>
          </Box>
          <CheckerCancellationTable data-id="element-2722" />
        </Box>
      </Box>
    </Box>;
};
export default CheckerInboxCancellation;